import { createContext, useContext } from 'react';

const ToastContext = createContext();

function useToastContext() {
  return useContext(ToastContext);
}

export default ToastContext;
export { useToastContext };
